import { render, staticRenderFns } from "./enroll-sixman-add.vue?vue&type=template&id=f86e0da0&lang=pug"
import script from "./enroll-sixman-add.vue?vue&type=script&lang=js"
export * from "./enroll-sixman-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports